import { render, staticRenderFns } from "./RefundShippingCard.vue?vue&type=template&id=5ae5491a&scoped=true&"
import script from "./RefundShippingCard.vue?vue&type=script&lang=js&"
export * from "./RefundShippingCard.vue?vue&type=script&lang=js&"
import style0 from "./RefundShippingCard.vue?vue&type=style&index=0&id=5ae5491a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae5491a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4088215791/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ae5491a')) {
      api.createRecord('5ae5491a', component.options)
    } else {
      api.reload('5ae5491a', component.options)
    }
    module.hot.accept("./RefundShippingCard.vue?vue&type=template&id=5ae5491a&scoped=true&", function () {
      api.rerender('5ae5491a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/containers/Customer/OrderWidget/Refund/RefundShippingCard.vue"
export default component.exports